import moment from "moment";

import {
  dateFormat,
  localInputShortDateFormat,
  taskFieldInputShortDateFormat,
} from "../containers/smart/camunda/constants/formats";
import { language } from "../language";

export const extractDate = (date) => {
  const offset = date.getTimezoneOffset();
  const newDate = new Date(date.getTime() - offset * 60 * 1000);
  return newDate.toISOString().split("T")[0];
};

export const extractISODate = (date) => {
  return date.split("T")[0];
};

export const formatToLocalDate = (date) => {
  let res = "";
  if (date) {
    const dt = new Date(date);
    if (dt !== "Invalid Date") {
      res = dt.toLocaleString();
    }
  }
  return res;
};

export const formatCamundaDateTaskField = (date) => {
  const dateFormats = [
    taskFieldInputShortDateFormat,
    localInputShortDateFormat,
  ];

  let formattedValue = moment(date, dateFormats, true).format(
    taskFieldInputShortDateFormat,
  );

  if (String(formattedValue) === "Invalid date") {
    const dateUtc = new Date(date);
    formattedValue = moment(extractISODate(dateUtc.toISOString())).format(
      taskFieldInputShortDateFormat,
    );
  }

  return formattedValue;
};

/**
 * Converte a data para o formato YYYY-MM-DD[T]HH:mm:ss.SSS ou então retorna null caso a data seja invalida
 * @param {*} date
 * @returns
 */
export const formatCamundaDate = (date) => {
  let formatedValue = formatCamundaDateTaskField(date);

  if (String(formatedValue) !== "Invalid date") {
    formatedValue = moment(formatedValue).format(dateFormat);
  }

  if (String(formatedValue) === "Invalid date") {
    formatedValue = null;
  }

  return formatedValue;
};

export const formatDataVencimento = (dueDate) => {
  let res = language.NoExpirationDate;
  if (dueDate) {
    const dt = new Date(dueDate);
    let days = 0;

    if (dt !== "Invalid Date") {
      const dayMilisec = 1000 * 60 * 60 * 24; //Dia em milisegundos
      const hourMilisec = 1000 * 60 * 60;
      const minuteMilisec = 1000 * 60;

      const remainingTime = dt.getTime() - Date.now();

      if (remainingTime >= dayMilisec) {
        days = Math.floor(remainingTime / dayMilisec);
        res =
          `${days} ${days > 1 ? language.dueDateDays : language.Day}`.toLowerCase();
      } else if (remainingTime >= hourMilisec) {
        days = Math.floor(remainingTime / hourMilisec);
        res =
          `${days} ${days > 1 ? language.hours : language.hour}`.toLowerCase();
      } else if (remainingTime >= minuteMilisec) {
        days = Math.floor(remainingTime / minuteMilisec);
        res =
          `${days} ${days > 1 ? language.minutes : language.minute}`.toLowerCase();
      } else {
        res = `${days} ${language.minutes}`.toLowerCase();
      }
    } else {
      res = `${days} ${language.minutes}`.toLowerCase();
    }
  }

  return res;
};
